// extracted by mini-css-extract-plugin
export default {"ComponentHolder":"LoadingComponet_ComponentHolder__Z9FPW"};